


























































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import StandardLayoutChangePassword from '@/layouts/standard/components/StandardLayoutChangePassword.vue';
import { UserStore } from '@/store/user';

@Component({
  components: {
    StandardLayoutChangePassword,
  },
})
export default class StandardLayoutMenu extends Vue {
  @Action reset!: () => void;
  @UserStore.Bind.State user!: UserStore.State<'user'>;

  isChangePasswordShown = false;

  async handleLogOutClick() {
    await this.reset();
    this.$router.push('/login');
  }

  get shortName() {
    const username = this.user && this.user.username;
    const usernameEndIndex = username.indexOf('@');

    return usernameEndIndex >= 0
      ? username.substring(0, usernameEndIndex)
      : username;
  }
}
